<mat-form-field [style.width.%]="100">
  <mat-label>{{ placeholder | titlecase }}</mat-label>
  <input name="searchfilter" matInput [formControl]="formControl" class="search-input" autocomplete="off">
</mat-form-field>
